"use strict";

import "./less/_main.less";
// import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';

window.$ = $;
window.bootbox = bootbox;

// Set jQuery validator defaults
if (jQuery.validator) {
	jQuery.validator.setDefaults({
		highlight: function (element) {
			$(element).closest('.form-group').addClass('has-error');
		},
		unhighlight: function (element) {
			$(element).closest('.form-group').removeClass('has-error');
		},
		errorElement: 'em',
		errorClass: 'error-block',
		errorPlacement: function (error, element) {
			if (element.hasClass('groupcb')) error.insertAfter(element.closest('table'));
			else if (element.parent('.input-group').length) error.insertAfter(element.parent());
			else if (element.parent().parent('.checkbox').length) error.insertAfter(element.parent().parent().parent().parent());
			else error.insertAfter(element);
		}
	});

	// Validator message defaults
	jQuery.validator.messages.required = 'Required';
	jQuery.validator.messages.remote = 'Needs attention';
	jQuery.validator.messages.email = 'Invalid email address';
	jQuery.validator.messages.url = 'Invalid URL';
	jQuery.validator.messages.date = 'Invalid Date';
	jQuery.validator.messages.number = 'Valid number required';
	jQuery.validator.messages.digits = 'Only digits allowed';
	jQuery.validator.messages.equalTo = 'Values do not match';
	jQuery.validator.messages.maxlength = jQuery.validator.format("Exceeds {0}-character maximum");
	jQuery.validator.messages.minlength = jQuery.validator.format("At least {0} characters required");
	jQuery.validator.messages.rangelength = jQuery.validator.format("{0}-{1} characters required");
	jQuery.validator.messages.range = jQuery.validator.format("Value between {0}-{1} required");
	jQuery.validator.messages.max = jQuery.validator.format("Maximum value is {0}");
	jQuery.validator.messages.min = jQuery.validator.format("Minimum value is {0}");

	// Validator custom rules
	var msg = $.validator.messages.maxlength;
	jQuery.validator.addMethod("maxtextarea", function (value, element, param) {
		if (value === undefined || value === '') return true;
		var len = value.length;
		if (len > param) {
			msg = "Exceeds " + param + "-character max by " + (len - param).toString();
			return false;
		} else return true;
	}, function () { return msg; });
}

$(function () {
	// $('#menubtn').off('vclick.activate');

	// $('#menu .submenu').removeClass('open');

	var $navcontainer = $('nav');

	// Mobile menu toggle event
	$('#menubtn').on('click', function (e) {
		e.preventDefault();
		$navcontainer.addClass('activated');
	});

	// Close mobile menu
	$('#menu .menu-close a, #navOverlay').on('click', function (e) {
		e.preventDefault();
		$navcontainer.removeClass('activated');
		$navcontainer.find('.submenu.open').removeClass('open');
	});



	// $("#slider").show().addClass("flex").slideReveal({
	// 	trigger: $("#mobileNav"),
	// 	push: false,
	// 	overlay: true,
	// 	position:"right"
	// });
	// $("#closeNav").click(function(e) {
	// 	$("#slider").slideReveal("hide");
	// });
	// var hpswiper = new Swiper("#hpswiper", {
	// 	autoplay: 8000,
	// 	loop: true,
	// 	nextButton: "#next",
	// 	prevButton: "#prev",
	// 	pagination: "#pagination",
	// 	paginationHide: false,
	// 	paginationClickable: true
	// });
	
	var emailIsValid = function(email) {
		var re = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
		return re.test(email);
	};
	$.validator.addMethod("email", function(e) {
		return emailIsValid(e);
	}, "Please enter a valid email");

	var warehouseQuoteFormOpts = {
		onkeyup: false,
		focusInvalid: false,
		onfocusout: false,
		ignore: [],		
		groups: {
		
		},
		rules: {
			"FirstName": "required",
			"LastName": "required",
			"Address": "required",
			"EstimatedDateNeeded": "required",
			"EstimatedMonthsNeeded": "required",
			"City": "required",			
			"Zip": "required",
			"DeliveryZip": "required",
			"DeliveryAddress": "required",
			"MoveZip":{
				required:
					function () {
						return $("#Quote_Needs").val() !== "S";
					}
			},
			"MoveAddress": {
				required:
					function () {
						return $("#Quote_Needs").val() !== "S";
					}
			},
			"PhoneNumber": "required",
			"Email": {
				required: true,
				email: true
			}
		}		
	};
	$("#warehouseQuoteForm").validate(warehouseQuoteFormOpts);
	

	$(".galimg").click(function (e) {
		$("#mainImg").prop("src", e.target.parentElement.dataset.barrImgurl);
	});
});


// WEBPACK FOOTER //
// ./src/global.js